// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/contactus1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/contactus2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assets/Images/line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Assets/Images/contactus3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs_contact__XVDUQ {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 {
  display: flex;
  width: 80%;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
}
@media (max-width: 1200px) {
  .ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 {
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media (max-width: 600px) {
  .ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 {
    width: 90%;
    padding: 30px 0;
  }
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_text__lPqkO {
  text-align: center;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_text__lPqkO h1 {
  font-weight: 400;
  font-size: 36px;
  color: #FFFFFF;
  text-shadow: 3px 4px 4px rgba(255, 255, 255, 0.25);
  font-family: "hemi_head";
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_text__lPqkO h3 {
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  font-family: "hemi_head";
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_text__lPqkO h3 span {
  color: #ED1C24;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_text__lPqkO p {
  font-size: 20px;
  color: #ffffff;
  max-width: 400px;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn {
  background: rgba(217, 217, 217, 0.22);
  box-shadow: -3px -3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);
  border-radius: 40px;
  padding: 30px 70px;
}
@media (max-width: 600px) {
  .ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn {
    width: 100%;
    padding: 30px;
  }
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn h3 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn p {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: none;
  margin-bottom: 20px;
  padding: 0;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset input {
  width: 416px;
  height: 46px;
  background: #FFFFFF;
  border-radius: 10px;
  outline: none;
  border: none;
  padding: 7px;
}
@media (max-width: 600px) {
  .ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset input {
    width: 100%;
  }
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset label {
  font-weight: 600;
  font-size: 15px;
  font-family: "Roboto Light";
  color: #FFFFFF;
  margin-bottom: 10px;
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset textarea {
  width: 416px;
  height: 100px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 7px;
}
@media (max-width: 600px) {
  .ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset textarea {
    width: 100%;
  }
}
.ContactUs_contact__XVDUQ .ContactUs_container__6PgU4 .ContactUs_form__EyiAn button {
  width: 127px;
  height: 53px;
  background: #020202;
  border-radius: 5px;
  filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);
  font-family: "hemi_head";
  cursor: pointer;
}

.ContactUs_contact1__phxCi {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: cover;
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 {
  display: flex;
  width: 80%;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
}
@media (max-width: 1200px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 {
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 {
    width: 90%;
    padding: 30px 0;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_text__lPqkO {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  filter: drop-shadow(4px 4px 10px rgba(255, 255, 255, 0.25));
  padding: 30px;
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_text__lPqkO p {
  font-size: 20px;
  color: #ffffff;
  max-width: 400px;
  font-family: Roboto;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn {
    width: 100%;
    padding: 30px;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn h3 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn p {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn .ContactUs_blocks__OmUDp {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn .ContactUs_blocks__OmUDp {
    width: 100%;
    flex-wrap: wrap;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: none;
  margin-bottom: 30px;
  padding: 0;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset {
    width: 100%;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset input {
  width: 200px;
  height: 46px;
  background: #FFFFFF;
  border-radius: 10px;
  outline: none;
  padding: 7px;
  border: none;
  margin-right: 30px;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset input {
    width: 100%;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset label {
  font-weight: 600;
  font-size: 15px;
  font-family: "Roboto";
  color: #FFFFFF;
  margin-bottom: 10px;
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset label span {
  color: #DD0000;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn fieldset label {
    font-size: 14px;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn select {
  width: 95%;
  height: 46px;
  border-radius: 10px;
  outline: none;
  padding: 7px;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn select {
    width: 100%;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn textarea {
  width: 95%;
  height: 100px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 7px;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn textarea {
    width: 100%;
  }
}
.ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn button {
  height: 53px;
  padding: 10px 20px;
  background: #ffffff;
  border-radius: 5px;
  filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));
  font-weight: 400;
  font-size: 20px;
  letter-spacing: 0.01em;
  color: #020202;
  text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);
  font-family: "hemi_head";
  float: right;
  margin-right: 30px;
}
@media (max-width: 600px) {
  .ContactUs_contact1__phxCi .ContactUs_container__6PgU4 .ContactUs_form__EyiAn button {
    padding: 5px;
    font-size: 18px;
    margin-right: 0;
  }
}

.ContactUs_line__zxh5e {
  height: 250px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
  background-size: 110%;
}
@media (max-width: 600px) {
  .ContactUs_line__zxh5e {
    height: 100px;
  }
}

.ContactUs_contact2__TXHlO {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
  background-size: cover;
}

.ContactUs_title__6fBYb {
  text-align: center;
}
.ContactUs_title__6fBYb h2 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
}
.ContactUs_title__6fBYb h2:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}

.ContactUs_map__LF1cm {
  width: 80%;
  margin: auto;
}
.ContactUs_map__LF1cm iframe {
  width: 100%;
}

.ContactUs_custom_file_input__LeiFn::-webkit-file-upload-button {
  visibility: visible;
  background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
}

.ContactUs_custom_file_input__LeiFn:hover {
  border-color: black;
}

.ContactUs_file_input__input__IcCI9 {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  width: 80% !important;
  max-width: 400px;
}

.ContactUs_file_input__label__KDoH9 {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
  padding: 10px 12px;
  background-color: #DD0000;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
}

.ContactUs_file_input__label__KDoH9 svg {
  height: 16px;
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ContactUs/ContactUs.module.scss"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AACF;AACE;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAAI;EAPF;IAQI,eAAA;IACA,uBAAA;EAGJ;AACF;AAFI;EAXF;IAYI,UAAA;IACA,eAAA;EAKJ;AACF;AAHI;EACE,kBAAA;AAKN;AAHM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kDAAA;EACA,wBAAA;AAKR;AAFM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;AAIR;AAFQ;EACE,cAAA;AAIV;AAAM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAER;AAEI;EACE,qCAAA;EACA,0FAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AACM;EALF;IAMI,WAAA;IACA,aAAA;EAEN;AACF;AAAM;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,6GAAA;AAER;AAEM;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6GAAA;AAAR;AAIM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAFR;AAIQ;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AAFV;AAGU;EARF;IASI,WAAA;EAAV;AACF;AAGQ;EACE,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AADV;AAIQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAFV;AAGU;EANF;IAOI,WAAA;EAAV;AACF;AAIM;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,0DAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,yFAAA;EACA,wBAAA;EACA,eAAA;AAFR;;AASA;EACE,oEAAA;EACA,sBAAA;AANF;AASE;EACE,aAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAPJ;AAQI;EAPF;IAQI,eAAA;IACA,uBAAA;EALJ;AACF;AAMI;EAXF;IAYI,UAAA;IACA,eAAA;EAHJ;AACF;AAKI;EACE,qCAAA;EACA,mBAAA;EACA,2DAAA;EACA,aAAA;AAHN;AAKM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAQM;EADF;IAEI,WAAA;IACA,aAAA;EALN;AACF;AAOM;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,6GAAA;AALR;AASM;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6GAAA;AAPR;AAWM;EACE,aAAA;EACA,8BAAA;AATR;AAUQ;EAHF;IAII,WAAA;IACA,eAAA;EAPR;AACF;AASQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAPV;AAQU;EAPF;IAQI,WAAA;EALV;AACF;AAOU;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AALZ;AAMY;EATF;IAUI,WAAA;EAHZ;AACF;AAMU;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AAJZ;AAKY;EACE,cAAA;AAHd;AAKY;EATF;IAUI,eAAA;EAFZ;AACF;AAKM;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAHR;AAIQ;EANF;IAOI,WAAA;EADR;AACF;AAGM;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AADR;AAEQ;EANF;IAOI,WAAA;EACR;AACF;AACM;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0DAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,yFAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;AACR;AAAQ;EAdF;IAeI,YAAA;IACA,eAAA;IACA,eAAA;EAGR;AACF;;AAIA;EACE,aAAA;EACA,oEAAA;EACA,qBAAA;AADF;AAEE;EAJF;IAKI,aAAA;EACF;AACF;;AAEA;EACE,oEAAA;EACA,sBAAA;AACF;;AACA;EACE,kBAAA;AAEF;AADE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAGJ;AADI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAGN;;AACA;EACE,UAAA;EACA,YAAA;AAEF;AADE;EACE,WAAA;AAGJ;;AAAA;EACE,mBAAA;EACA,0DAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AADA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AAIF;;AADA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;AAIF;;AADA;EACE,YAAA;EACA,iBAAA;AAIF","sourcesContent":[".contact {\n  background: url(\"../../Assets/Images/contactus1.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  .container {\n    display: flex;\n    width: 80%;\n    margin: auto;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px 0;\n    @media (max-width: 1200px) {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n    @media (max-width: 600px) {\n      width: 90%;\n      padding: 30px 0;\n    }\n\n    .text {\n      text-align: center;\n\n      h1 {\n        font-weight: 400;\n        font-size: 36px;\n        color: #FFFFFF;\n        text-shadow: 3px 4px 4px rgba(255, 255, 255, 0.25);\n        font-family: \"hemi_head\";\n      }\n\n      h3 {\n        font-weight: 400;\n        font-size: 24px;\n        color: #ffffff;\n        font-family: \"hemi_head\";\n\n        span {\n          color: #ED1C24;\n        }\n      }\n\n      p {\n        font-size: 20px;\n        color: #ffffff;\n        max-width: 400px;\n      }\n    }\n\n    .form {\n      background: rgba(217, 217, 217, 0.22);\n      box-shadow: -3px -3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);\n      border-radius: 40px;\n      padding: 30px 70px;\n      @media (max-width: 600px) {\n        width: 100%;\n        padding: 30px;\n      }\n\n      h3 {\n        font-family: 'hemi_head';\n        font-style: italic;\n        font-weight: 400;\n        font-size: 24px;\n        color: #FFFFFF;\n        filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));\n\n      }\n\n      p {\n        font-family: 'hemi_head';\n        font-style: italic;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 18px;\n        color: #FFFFFF;\n        filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));\n\n      }\n\n      fieldset {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        border: none;\n        margin-bottom: 20px;\n        padding: 0;\n\n        input {\n          width: 416px;\n          height: 46px;\n          background: #FFFFFF;\n          border-radius: 10px;\n          outline: none;\n          border: none;\n          padding: 7px;\n          @media (max-width: 600px) {\n            width: 100%;\n          }\n        }\n\n        label {\n          font-weight: 600;\n          font-size: 15px;\n          font-family: \"Roboto Light\";\n          color: #FFFFFF;\n          margin-bottom: 10px;\n        }\n\n        textarea {\n          width: 416px;\n          height: 100px;\n          background: #FFFFFF;\n          border-radius: 10px;\n          padding: 7px;\n          @media (max-width: 600px) {\n            width: 100%;\n          }\n        }\n      }\n\n      button {\n        width: 127px;\n        height: 53px;\n        background: #020202;\n        border-radius: 5px;\n        filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));\n        font-weight: 400;\n        font-size: 20px;\n        letter-spacing: 0.01em;\n        color: #FFFFFF;\n        text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);\n        font-family: \"hemi_head\";\n        cursor: pointer;\n      }\n\n    }\n  }\n}\n\n.contact1 {\n  background: url(\"../../Assets/Images/contactus2.png\") no-repeat center;\n  background-size: cover;\n\n\n  .container {\n    display: flex;\n    width: 80%;\n    margin: auto;\n    justify-content: space-between;\n    align-items: center;\n    padding: 50px 0;\n    @media (max-width: 1200px) {\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n    @media (max-width: 600px) {\n      width: 90%;\n      padding: 30px 0;\n    }\n\n    .text {\n      background: rgba(255, 255, 255, 0.06);\n      border-radius: 16px;\n      filter: drop-shadow(4px 4px 10px rgba(255, 255, 255, 0.25));\n      padding: 30px;\n\n      p {\n        font-size: 20px;\n        color: #ffffff;\n        max-width: 400px;\n        font-family: Roboto;\n      }\n    }\n\n    .form {\n      @media (max-width: 600px) {\n        width: 100%;\n        padding: 30px;\n      }\n\n      h3 {\n        font-family: 'hemi_head';\n        font-style: italic;\n        font-weight: 400;\n        font-size: 24px;\n        color: #FFFFFF;\n        filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));\n\n      }\n\n      p {\n        font-family: 'hemi_head';\n        font-style: italic;\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 18px;\n        color: #FFFFFF;\n        filter: drop-shadow(0px 2px 4px rgba(255, 255, 255, 0.25)) drop-shadow(1px 2px 4px rgba(255, 255, 255, 0.25));\n\n      }\n\n      .blocks {\n        display: flex;\n        justify-content: space-between;\n        @media (max-width: 600px) {\n          width: 100%;\n          flex-wrap: wrap;\n        }\n      }\n        fieldset {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          border: none;\n          margin-bottom: 30px;\n          padding: 0;\n          @media (max-width: 600px) {\n            width: 100%;\n          }\n\n          input {\n            width: 200px;\n            height: 46px;\n            background: #FFFFFF;\n            border-radius: 10px;\n            outline: none;\n            padding: 7px;\n            border: none;\n            margin-right: 30px;\n            @media (max-width: 600px) {\n              width: 100%;\n            }\n          }\n\n          label {\n            font-weight: 600;\n            font-size: 15px;\n            font-family: \"Roboto\";\n            color: #FFFFFF;\n            margin-bottom: 10px;\n            span{\n              color: #DD0000;\n            }\n            @media (max-width: 600px) {\n              font-size: 14px;\n            }\n          }\n        }\n      select{\n        width: 95%;\n        height: 46px;\n        border-radius: 10px;\n        outline: none;\n        padding: 7px;\n        @media (max-width: 600px) {\n          width: 100%;\n        }\n      }\n      textarea {\n        width: 95%;\n        height: 100px;\n        background: #FFFFFF;\n        border-radius: 10px;\n        padding: 7px;\n        @media (max-width: 600px) {\n          width: 100%;\n        }\n      }\n      button {\n        height: 53px;\n        padding: 10px 20px;\n        background: #ffffff;\n        border-radius: 5px;\n        filter: drop-shadow(3px 3px 4px rgba(255, 255, 255, 0.25));\n        font-weight: 400;\n        font-size: 20px;\n        letter-spacing: 0.01em;\n        color: #020202;\n        text-shadow: 3px 1px 4px rgba(255, 255, 255, 0.25), 3px 1px 4px rgba(255, 255, 255, 0.25);\n        font-family: \"hemi_head\";\n        float: right;\n        margin-right: 30px;\n        @media (max-width: 600px) {\n          padding: 5px;\n          font-size: 18px;\n          margin-right: 0;\n        }\n      }\n\n    }\n  }\n}\n\n.line {\n  height: 250px;\n  background: url(\"../../Assets/Images/line.png\") no-repeat center;\n  background-size: 110%;\n  @media (max-width: 600px) {\n    height: 100px\n  }\n\n}\n.contact2{\n  background: url(\"../../Assets/Images/contactus3.png\") no-repeat center;\n  background-size: cover;\n}\n.title{\n  text-align: center;\n  h2 {\n    font-family: \"hemi_head\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 40px;\n    text-align: center;\n    letter-spacing: 0.01em;\n    color: #FFFFFF;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 30px;\n\n    &:before {\n      content: \"\";\n      width: 80%;\n      height: 1px;\n      position: absolute;\n      bottom: -10px;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: #ED1C24;\n    }\n  }\n}\n.map{\n  width: 80%;\n  margin: auto;\n  iframe{\n    width: 100%;\n  }\n}\n.custom_file_input::-webkit-file-upload-button {\n  visibility: visible;\n  background:  -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);\n  text-shadow: 1px 1px #fff;\n  font-weight: 700;\n  font-size: 10pt;\n  border: 1px solid #999;\n  border-radius: 3px;\n  padding: 5px 8px;\n  outline: none;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.custom_file_input:hover{\n  border-color: black;\n}\n\n.file_input__input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n  width: 80% !important;\n  max-width: 400px;\n}\n\n.file_input__label {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  font-size: 14px;\n  padding: 10px 12px;\n  background-color: #DD0000;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);\n}\n\n.file_input__label svg {\n  height: 16px;\n  margin-right: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact": `ContactUs_contact__XVDUQ`,
	"container": `ContactUs_container__6PgU4`,
	"text": `ContactUs_text__lPqkO`,
	"form": `ContactUs_form__EyiAn`,
	"contact1": `ContactUs_contact1__phxCi`,
	"blocks": `ContactUs_blocks__OmUDp`,
	"line": `ContactUs_line__zxh5e`,
	"contact2": `ContactUs_contact2__TXHlO`,
	"title": `ContactUs_title__6fBYb`,
	"map": `ContactUs_map__LF1cm`,
	"custom_file_input": `ContactUs_custom_file_input__LeiFn`,
	"file_input__input": `ContactUs_file_input__input__IcCI9`,
	"file_input__label": `ContactUs_file_input__label__KDoH9`
};
export default ___CSS_LOADER_EXPORT___;
